module.exports = "<span class=\"lpview_tabButton tabButtonText\" title=\"{{titleText}}\" tooltip-align=\"left\" tooltip-delay=\"1500\">{{titleText}}</span>";